import { MessageService } from './message.service';
import { Injectable } from '@angular/core';

import Inputmask from "inputmask";

@Injectable({
  providedIn: 'root',
})
export class ConfirmInputService {
  constructor(private messageService: MessageService) {}

  private inputConfirmed: boolean = false;

  changeInputStatus(inputStatus: boolean) {
    this.inputConfirmed = inputStatus;
  }

  async waitUserInput() {
    while (this.inputConfirmed === false) await this.messageService.timeout(50);
    this.inputConfirmed = false;
  }

  createHeightInput(input: HTMLInputElement, btn: HTMLButtonElement) {
    input.setAttribute("placeholder", "0,00 m");
    input.setAttribute("id", "height-input");

    Inputmask({
      mask: "9,99 m",
      placeholder: "0",
      numericInput: true,
      rightAlign: false,
      greedy: false,
    }).mask(input);
  }

  createWeightInput(input: HTMLInputElement, btn: HTMLButtonElement) {
    input.setAttribute("placeholder", "00,0 kg");
    input.setAttribute("id", "weight-input");

    Inputmask({
      mask: "[9][9]9,9 kg",
      placeholder: "0",
      numericInput: true,
      rightAlign: false,
      greedy: false,
    }).mask(input);
  }
}
